import React from "react";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";
import { appendBackgroundImage } from "@sendmagic/prismic-nextjs/src/helpers/images";

// import "./styles/TextOnlyBanner.module.scss";

const BorderedVariationSection = ({ doc, StartOrderBtn }) => {
  const { primary: { heading, paragraph_text, internal_link_id } = {}, items = [] } = doc;
  return (
    <div className="container snackbox-block">
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      {checkContentPresence(heading) && (
        <div className="text-theme-primary text-center text-only-slice-title same-size-title font-weight-bold">
          {textResolver(heading)}
        </div>
      )}
      {checkContentPresence(paragraph_text) && (
        <div className="mt-3 sns-h4 text-center px-lg-5 mx-lg-5 detail-text content-block-description paragraph-spacing">
          {textResolver(paragraph_text)}
        </div>
      )}
      <div className="mt-4 text-center">
        {items.map(({ link, link_text, start_an_order }) =>
          start_an_order && StartOrderBtn ? (
            <StartOrderBtn className="mx-2 mb-3 mb-md-0 py-3 d-inline-block text-white font-weight-bold no-underline text-uppercase text-break ls-3 button-marketing">
              {textResolver(link_text)}
            </StartOrderBtn>
          ) : (
            link?.url && (
              <PrismicLinkTag
                urlText={link_text}
                url={link?.url}
                target={link?.target}
                className="mx-2 mb-3 mb-md-0 py-3 d-inline-block text-white font-weight-bold no-underline text-uppercase text-break ls-3 button-marketing"
              />
            )
          ),
        )}
      </div>
    </div>
  );
};

const BorderedVariation = ({ doc, StartOrderBtn }) => {
  const { primary: { desktop_bg_image, mobile_bg_image, background_color } = {} } = doc;
  const sectionDeskTopStyle = {
    ...appendBackgroundImage(desktop_bg_image?.url),
    backgroundColor: background_color,
  };
  const sectionMobileStyle = {
    ...appendBackgroundImage(mobile_bg_image?.url),
    backgroundColor: background_color,
  };
  return (
    <>
      <div
        className="py-md-5 pt-5 pb-3 d-none d-md-block text-only-slice bordered-slice prismic-slice"
        style={sectionDeskTopStyle}
      >
        <BorderedVariationSection doc={doc} StartOrderBtn={StartOrderBtn} />
      </div>
      <div
        className="py-md-5 pt-5 pb-3 d-block d-md-none text-only-slice bordered-slice prismic-slice"
        style={sectionMobileStyle}
      >
        <BorderedVariationSection doc={doc} StartOrderBtn={StartOrderBtn} />
      </div>
    </>
  );
};

export default BorderedVariation;
